module.exports = __webpack_public_path__ + "assets/img/FormPiper-Landing-Page-+-Website-w540.62202398.jpg";